// Resolve template placeholders before merging both retained and streamed rows.
export function resolveOmissionTargets(rows, identity) {
  const fields=['drive_file_id','target_drive_file_id','file_index','filename','file_name'];
  const groups=new Map(),result=rows.map(row=>row&&typeof row==='object'?{...row}:row);
  result.forEach((row,index)=>{
    if(row?.type!=='omission')return;
    const key=JSON.parse(identity(row));
    if(!Array.isArray(key)||!['criterion','row'].includes(key[3]?.[0]))return;
    const target=key[1];key[1]=null;
    const scope=JSON.stringify(key);
    if(!groups.has(scope))groups.set(scope,[]);
    groups.get(scope).push({index,target});
  });
  for(const entries of groups.values()){
    const targets=new Map(entries.filter(e=>e.target!==null).map(e=>[JSON.stringify(e.target),result[e.index]]));
    if(targets.size!==1)continue;
    const concrete=targets.values().next().value;
    for(const entry of entries){
      if(entry.target!==null)continue;
      for(const field of fields)if(concrete[field]!==null&&concrete[field]!==undefined)result[entry.index][field]=concrete[field];
    }
  }
  return result;
}
